import {
  BOTTOM_NAVIGATOR_TRADE_CARD_HEIGHT,
  BOTTOM_NAVIGATOR_TRADE_CARD_WIDTH,
} from "features/dashboard/common/constants";
import React from "react";
import { TradeData } from "@shared/types";
import useTradeCard from "features/dashboard/common/useTradeCard";
import { StyledCard } from "features/dashboard/common/styles";
import { useMobileTradePriceChart } from "@shared/features/dashboard/hooks";
import TradeChart from "features/dashboard/MobileDashboard/TradeChart";

interface MobileTradeCardProps {
  tradeData: TradeData;
  isLoading?: boolean;
}

const MobileTradeCard = ({ tradeData, isLoading }: MobileTradeCardProps) => {
  const { graphData, precision, formattedGraphData, currentPrice } =
    useMobileTradePriceChart(tradeData);

  const {
    openTradeExtraDetails,
    topSection,
    bottomSection,
    isTradeClosed,
    annotations,
  } = useTradeCard({
    tradeData,
    graphData,
  });

  return (
    <StyledCard
      onClick={openTradeExtraDetails}
      $isClosed={!!isTradeClosed}
      $isMobile={true}
      style={cardStyle}
    >
      {topSection}
      <TradeChart
        formattedGraphData={formattedGraphData}
        currentPrice={currentPrice}
        precision={precision}
        isLoading={isLoading}
        annotations={annotations}
      />
      {bottomSection}
    </StyledCard>
  );
};

export default React.memo(MobileTradeCard);

const cardStyle = {
  height: BOTTOM_NAVIGATOR_TRADE_CARD_HEIGHT,
  width: BOTTOM_NAVIGATOR_TRADE_CARD_WIDTH,
};
